import { API } from './connection'
import axios from 'axios'

// Respuesta de petición fallida.
const failureResponse = {
    data: { message: 'Fallo en la solicitud' },
    status: 500,
    statusText: 'Failed Request',
    success: false,
}
// Respuesta de petición cancelada.
const cancellationResponse = {
    data: { message: 'Solicitud Cancelada' },
    status: 499,
    statusText: 'Client Closed Request',
    success: false,
}

const buildResponse = (response) => {
    const { data, status, statusText } = response
    const success = status >= 200 && status < 300
    return { data, status, statusText, success }
}
const request = async (method, ...args) => {
    try {
        const res = await API[method](...args)
        return buildResponse(res)
    } catch (error) {
        if (axios.isCancel(error)) {
            return cancellationResponse
        }
        if (error.response) {
            return buildResponse(error.response)
        }
        return failureResponse
    }
}

export const BaseRequest = {
    get: async (url, config = {}) => request('get', url, config),
    post: async (url, data = {}, config = {}) => request('post', url, data, config),
    put: async (url, data = {}, config = {}) => request('put', url, data, config),
    patch: async (url, data = {}, config = {}) => request('patch', url, data, config),
    delete: async (url, config = {}) => request('delete', url, config),
}
